import Brands from "./sections/brands";
import Footer from "./sections/footer";
import Groups from "./sections/groups";
import Navbar from "./sections/navbar";
import Presentation from "./sections/presentation";
import Process from "./sections/process";
import Mission from "./sections/mission";
import Diagram from "./sections/diagram";
import Experience from "./sections/experience";
import Retailers from "./sections/retailers";
import PopUp from "./sections/popUp";
import Form from "./sections/form";
import Branding from "./sections/branding";
import AdsLanding from "./sections/adsLanding";
import { TranslatorProvider, translate } from "react-translate";
import Modal from "react-modal";
import { translations } from "./utils/data";
import { useState } from "react";
import "./App.css";

let Navbar2      = translate("Home")(({ t, setNumber }) => <Navbar t={t} setNumber={setNumber} />);
let Presentation2 = translate("Home")((t) => <Presentation {...t} />);
let Retailers2   = translate("Home")(({ t }) => <Retailers t={t} />);
let Brands2      = translate("Home")((t) => <Brands {...t} />);
let Branding2    = translate("Home")((t) => <Branding {...t} />);
let Diagram2     = translate("Home")(({ t }) => <Diagram t={t} />);
let Groups2      = translate("Home")((t) => <Groups {...t} />);
let Process2     = translate("Home")(({ t }) => <Process t={t} />);
let Mission2     = translate("Home")(({ t }) => <Mission t={t} />);
let Experience2  = translate("Home")(({ t }) => <Experience t={t} />);
let Footer2      = translate("Home")(({ t }) => <Footer t={t} />);
let Form2        = translate("Home")((t) => <Form {...t} />);
let AdsLanding2   = translate("Home")((t) => <AdsLanding {...t} />);

Modal.setAppElement("#root");

// Dedicated, distraction-free page for paid traffic (Google Ads final URL
// should point to https://shelf-e.com/?lp=1&utm_source=google&utm_medium=cpc...).
// Checked once at module load — a hard reload always accompanies an ad click,
// so there is no need for this to be reactive to in-app navigation.
const isAdsLanding = new URLSearchParams(window.location.search).has("lp");

function App() {
  const [modalIsOpen, setIsOpen] = useState({ state: false, title: "" });
  const [number, setNumber] = useState(1);

  function openModal(title) { setIsOpen({ state: true, title }); }
  function closeModal()     { setIsOpen({ state: false, title: "" }); }

  if (isAdsLanding) {
    return (
      <div className="App" data-lang="es">
        <TranslatorProvider translations={translations[number]}>
          <AdsLanding2 number={number} />
        </TranslatorProvider>
      </div>
    );
  }

  return (
    <div className="App u-body u-overlap u-overlap-transparent u-xl-mode" data-lang="en">
      <TranslatorProvider translations={translations[number]}>
        {/* 1 — Navbar */}
        <Navbar2 setNumber={setNumber} />
        {/* 2 — Hero */}
        <Presentation2 openModal={openModal} />
        {/* 3 — Retailers marquee strip */}
        <Retailers2 />
        {/* 4 — ¿A quién va dirigido? */}
        <Brands2 openModal={openModal} />
        {/* 5 — Propósito / Intelligence diagram */}
        <Diagram2 />
        {/* 6 — Funcionalidades (14-slide carousel) */}
        <Process2 />
        {/* 7 — Branding CTA intermedio */}
        <Branding2 openModal={openModal} />
        {/* 8 — Misión */}
        <Mission2 />
        {/* 9 — Experiencia */}
        <Experience2 />
        {/* 10 — Nuestros resellers */}
        <Groups2 openModal={openModal} />
        {/* 11 — Footer */}
        <Footer2 />
        {/* Overlays */}
        <PopUp />
        <Form2
          modalIsOpen={modalIsOpen}
          openModal={openModal}
          closeModal={closeModal}
          number={number}
        />
      </TranslatorProvider>
    </div>
  );
}

export default App;
